import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Caption from './caption';
import MainContent from './mainContent';
import Interact from '../../../../../components/interact';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from 'ThreeTerminal_pc_dynamic';
import Chip from 'Chip';
import { getSeoAbDisplay } from '../../../../../../common/seoAbBucket';

class Artical extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        ad: PropTypes.object,
        hasCopyRight: PropTypes.bool,
        faceUrl: PropTypes.string,
        vestAccountDetail: PropTypes.object,
        subscribe: PropTypes.object,
        keywords: PropTypes.string,
        interact: PropTypes.object,
        sourceReason: PropTypes.string,
    };

    render() {
        const { content, ad, hasCopyRight, faceUrl, vestAccountDetail, subscribe, keywords, interact, sourceReason } =
            this.props;
        const {
            fhhAccountDetail,
            base62Id,
            title,
            newsTime,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            url,
            commentUrl,
            skey,
            voteId,
            isOriginal,
            contentData,
            editorName,
            editorCode,
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
            goodsPlugin,
            updateTime,
            seoAbValue,
            seoTitle,
            seoDescription,
            quanPlugin,
            type,
        } = content;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
            goodsPlugin,
        };
        const { articleTitle, articleSummary } = getSeoAbDisplay({
            title,
            seoAbValue,
            seoTitle,
            seoDescription,
            quanPlugin,
            type,
        });
        const date = newsTime.split(' ')[0];
        const time = newsTime.split(' ')[1];
        const dateTime = `${date.split('-')[0]}年${date.split('-')[1]}月${date.split('-')[2]}日 ${time}`;
        const followUrl = `//gentie.ifeng.com/c/comment/${base62Id}`;
        const captionData = {
            title: articleTitle,
            url,
            dateTime,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            commentUrl,
            followUrl,
            pcUrl,
            fhhAccountDetail,
            hasCopyRight,
            faceUrl,
            vestAccountDetail,
            subscribe,
            interact,
            updateTime,
            publishTime: newsTime,
        };

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        const commentConfig = {
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl,
            // 获取评论内容接口
            cmtNumUrl: `//${ commentDomain }/get.php`,
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: `//${ commentDomain }/post.php`,
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: `//${ commentDomain }/vote.php`,
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: `//${ commentDomain }/report`,
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
        };
        const isShowEditName = editorCode && (hasCopyRight || sourceReason === '公开信息');

        return (
            <div className={styles.artical}>
                <Caption content={captionData} />
                <MainContent
                    shareInfo={shareInfo}
                    content={contentData}
                    pluginData={pluginData}
                    ad={ad}
                    articleSummary={articleSummary}
                />
                <Chip id="222639" type="static" title="页底注入js脚本" groupName="页底注入js脚本">
                    <div className={styles.artical_line} id="articleEndBox" />
                </Chip>
                <div className="clear" />
                <div className={styles.vote_box}>
                    {isShowEditName ? <p className={styles.author}>{`[责任编辑：${editorName} ${editorCode}]`}</p> : ''}
                    {isOriginal !== '0' ? (
                        <p className={styles.copyrightInfo}>(本文章版权归凤凰网所有，未经授权，不得转载)</p>
                    ) : (
                        ''
                    )}
                    <div className="clear" />
                    <Interact keywords={keywords} voteId={voteId} shareInfo={shareInfo} content={interact} />
                </div>
                <div className={styles.comment_box}>
                    <LazyLoad>
                        <Comment articleInfo={commentConfig} />
                    </LazyLoad>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Artical);
